<template>
  <div
    class="mt-32 p-24 border-radius-lg bg-fill-tertiary-soft mt-sm-16 mx-sm-n16 p-sm-16 border-radius-sm-0"
    v-if="isDeliveryOptionsVisible"
  >
    <div class="grid-row grid-row_sm d-flex_middle fw-medium fs-20">
      <div class="grid-col">Получить в</div>
      <div class="grid-col">
        <div class="fw-medium fs-20 js-header-city">
          <a
            href="javascript:void(0);"
            data-href="/local/components/orteka/city.selector/ajax.php"
            class="btn color-tertiary hover-color-dark js-popup-link"
          >
            <span class="mr-8 js-city-current">
              г. {{ delivery.current_city }}</span
            >
            <span class="d-block icon-16">
              <svg>
                <use
                  xlink:href="/local/components/orteka/catalog.element/src/assets/images/sprite.svg#icon-chevron-right"
                ></use>
              </svg>
            </span>
          </a>
        </div>
      </div>
    </div>

    <div
      v-if="isCityPresence"
      @click="showPopupSalon()"
      class="link mt-16 relative grid-row grid-row_md fs-14 hover-color-hover-tertiary"
    >
      <div class="grid-col">
        <div class="icon-24 mt-2">
          <img
            src="/local/components/orteka/catalog.element/src/assets/images/icon-map.svg"
            alt="shop"
            class="img-cover"
          />
        </div>
      </div>

      <div class="grid-col grid-col_full">
        <span class="fs-16" :data-offer="store.getSelectedOffer?.id">
          Забрать в салоне
        </span>
        <div class="running">
          <div class="fw-semibold color-tertiary">
            {{ canReserve ? delivery.reserve_time : delivery.time }}, бесплатно
          </div>
        </div>
        <div class="text-dark">
          В
          <span v-if="getReserveSalons() > 0">
            наличии в
            <b
              >{{ getReserveSalons() }} салон{{ getEnd(getReserveSalons()) }}</b
            >
            <span v-if="moreSalons()">, еще в </span>
          </span>
          <span v-if="moreSalons()" class="fw-semibold"
            >{{ delivery.total_salons - getReserveSalons() }}
            {{
              getReserveSalons() == 0
                ? "салон" + getEnd(delivery.total_salons)
                : ""
            }}
            под заказ</span
          >
        </div>
      </div>
      <div class="grid-col">
        <div class="icon-12 mt-2">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/images/sprite.svg#icon-chevron-right"
            ></use>
          </svg>
        </div>
      </div>
    </div>

    <div
      v-if="canAddCart"
      @click="showCourierPopup()"
      class="link mt-16 relative grid-row grid-row_md fs-14 hover-color-hover-tertiary"
    >
      <div class="grid-col">
        <div class="icon-24 mt-2">
          <img
            src="/local/components/orteka/catalog.element/src/assets/images/icon-delivery2.svg"
            alt="delivery"
            class="img-cover"
          />
        </div>
      </div>
      <div class="grid-col grid-col_full">
        <span class="fs-16">Доставить курьером</span>
        <div class="running">
          <div class="fw-semibold color-tertiary">
            {{
              store.getSelectedOffer?.fast_delivery == true
                ? delivery.fast_time
                : delivery.courier_time
            }},
            {{
              store.getSelectedOffer?.fast_delivery == true
                ? delivery.fast_price_formatted
                : delivery.price
            }}
          </div>
        </div>
      </div>
      <div class="grid-col">
        <div class="icon-12 mt-2">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/images/sprite.svg#icon-chevron-right"
            ></use>
          </svg>
        </div>
      </div>
    </div>

    <div
      v-if="!notAvailable && canAddCart"
      @click="showPopup"
      class="link mt-16 relative grid-row grid-row_md fs-14 hover-color-hover-tertiary"
    >
      <div class="grid-col">
        <div class="icon-24">
          <img
            src="/local/components/orteka/catalog.element/src/assets/images/icon-shop2.svg"
            alt="map"
            class="img-cover"
          />
        </div>
      </div>
      <div class="grid-col grid-col_full">
        <span class="fs-16"> Доставить в пункт выдачи заказов </span>
        <div class="running">
          <div class="fw-semibold color-tertiary">
            Доставка {{ delivery.time }}, {{ delivery.price_pvz }}
          </div>
          <div class="text-dark">
            В один из
            <span class="fw-semibold">{{ delivery.total_pvz }} ПВЗ</span>
          </div>
        </div>
      </div>
      <div class="grid-col">
        <div class="icon-12 mt-2">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/images/sprite.svg#icon-chevron-right"
            ></use>
          </svg>
        </div>
      </div>
    </div>

    <!-- <div class="mt-24">
      <button
        class="btn btn_lg btn_px-lg border-radius-md btn_stroke-dark fs-18 w-100 fw-medium"
      >
        Заказать срочную доставку
      </button>
    </div>

    <div class="mt-8 text-center color-gray fs-14">Доставим от 4-х часов</div>-->
  </div>

  <teleport to="#product-element__popup-container-vue">
    <transition name="fade">
      <div class="popup d-flex_middle popup_md-bottom" v-if="isShow">
        <div class="popup__layout" @click="closePopup()"></div>
        <div
          class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
          v-bind:class="{ 'is-active': isAnimate }"
        >
          <div
            class="popup__block popup__block_md bg-white border-radius-xl p-24 p-md-16 mx-auto"
          >
            <div class="grid-row d-flex_middle d-flex_reverse">
              <div class="grid-col">
                <div
                  class="btn color-gray hover-color-dark"
                  @click="closePopup()"
                >
                  <Icon iconName="icon-close" className="icon-24" />
                </div>
              </div>

              <div class="grid-col grid-col_full">
                <div class="fw-medium">Доставка в пункты выдачи (ПВЗ)</div>
              </div>
            </div>

            <div class="fs-14">
              <div class="mt-20">
                Бесплатная доставка при заказе от 2000 рублей. При заказе до
                2000 рублей. Доставка платная: сумма рассчитывается по тарифу
                ТК.
              </div>
              <div>
                Пункты выдачи заказов:<br />
                СДЭК (онлайн-оплата, оплата наличными или банковской картой при
                получении)<br />
                Почта России (только онлайн-оплата)<br />
                5Post (все виды оплаты, частичный выкуп невозможен)<br />
                Обратите внимание: курьеры не являются специалистами в области
                медицины и не консультируют по изделиям.
              </div>
              <div class="mt-16">
                С тарифами доставки в вашем регионе вы можете ознакомиться на
                странице
                <a target="_blank" href="/delivery/" class="color-tertiary"
                  >Способы получения заказа</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- /popup__wrapper -->
      </div>
    </transition>
  </teleport>

  <teleport to="#product-element__popup-container-vue">
    <transition name="fade">
      <div class="popup d-flex_middle" v-if="isShowSalon">
        <div class="popup__layout" @click="closePopupSalon()"></div>
        <div
          class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
          v-bind:class="{ 'is-active': isAnimate }"
        >
          <div
            class="popup__block popup__block_md bg-white border-radius-xl p-24 p-md-16 mx-auto"
          >
            <div class="grid-row d-flex_middle d-flex_reverse">
              <div class="grid-col">
                <div
                  class="btn color-gray hover-color-dark"
                  @click="closePopupSalon()"
                >
                  <Icon iconName="icon-close" className="icon-24" />
                </div>
              </div>

              <div class="grid-col grid-col_full">
                <div class="fw-medium">Самовывоз из салона</div>
              </div>
            </div>

            <div class="fs-14">
              <div class="mt-20">
                Бесплатно, вне зависимости от суммы заказа. Срок хранения заказа
                в салоне - 6 дней
              </div>
            </div>
          </div>
        </div>
        <!-- /popup__wrapper -->
      </div>
    </transition>
  </teleport>

  <teleport to="#product-element__popup-container-vue">
    <transition name="fade">
      <div class="popup d-flex_middle" v-if="isShowCourier">
        <div class="popup__layout" @click="closeCourierPopup()"></div>
        <div
          class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
          v-bind:class="{ 'is-active': isAnimate }"
        >
          <div
            class="popup__block popup__block_md bg-white border-radius-xl p-24 p-md-16 mx-auto"
          >
            <div class="grid-row d-flex_middle d-flex_reverse">
              <div class="grid-col">
                <div
                  class="btn color-gray hover-color-dark"
                  @click="closeCourierPopup()"
                >
                  <Icon iconName="icon-close" className="icon-24" />
                </div>
              </div>

              <div class="grid-col grid-col_full">
                <div class="fw-medium">Доставка курьером</div>
              </div>
            </div>

            <div class="fs-14">
              <div v-if="delivery.region == 'msk'">
                <div class="mt-20">
                  <h3>Доставка по Москве (в пределах МКАД):</h3>
                  <div>Бесплатно* при сумме покупки от 2000 рублей;</div>
                  <div>250 рублей при сумме покупки менее 2000 рублей.</div>
                  <div>Интервалы доставки: 10:00 — 22:00;</div>
                  <div>Дни доставки: ежедневно</div>
                  <div>
                    *Если вы отказываетесь от заказа в момент его получения,
                    доставка становится платной – вы оплачиваете работу курьера
                    (250 руб.)
                  </div>
                </div>
                <div class="mt-20">
                  <h3>Доставка за пределами МКАД + вся Московская область:</h3>
                  <div>
                    Бесплатно* при сумме покупки от 2000 рублей (в пределах
                    МКАД).
                  </div>
                  <div>500 рублей при сумме покупки менее 2000 рублей.</div>
                  <div>Минимальная сумма заказа от 0 рублей.</div>
                  <div>Интервалы доставки: 10:00 — 21:00;</div>
                  <div>Дни доставки: ежедневно</div>
                  <div>
                    *Если вы отказываетесь от заказа в момент его получения,
                    доставка становится платной – вы оплачиваете работу курьера
                    (250 руб.)
                  </div>
                </div>
                <div class="mt-20">
                  <h3>Срочная доставка по Москве (в пределах МКАД):</h3>
                  <div>
                    Бесплатно* при сумме покупки от 2000 рублей (любая
                    удалённость от МКАД);
                  </div>
                  <div>
                    250 рублей при сумме покупки менее 2000 рублей (любая
                    удалённость от МКАД).
                  </div>
                  <div>Интервалы доставки: 10:00 — 21:00;</div>
                  <div>Дни доставки: ежедневно</div>
                  <div>
                    *Если вы отказываетесь от заказа в момент его получения,
                    доставка становится платной – вы оплачиваете работу курьера
                    (250 руб.)
                  </div>
                </div>
              </div>
              <div v-if="delivery.region == 'spb'">
                <div class="mt-20">
                  <h3>Доставка:</h3>
                  <div>
                    Бесплатно* при сумме покупки от 2000 рублей в рамках границ,
                    обозначенных сервисом доставки.
                  </div>
                  <div>500 рублей при сумме покупки менее 2000 рублей.</div>
                  <div>Минимальная сумма заказа от 0 рублей.</div>
                  <div>Интервалы доставки: 10:00 — 21:00;</div>
                  <div>Дни доставки: ежедневно</div>
                </div>
                <div class="mt-20">
                  <h3>Срочная доставка:</h3>
                  <div>Бесплатно* при сумме покупки от 2000 рублей;</div>
                  <div>
                    300 рублей, рублей при сумме покупки менее 2000 рублей.
                  </div>
                  <div>Интервалы доставки: 10:00 — 21:00;</div>
                  <div>Дни доставки: ежедневно</div>
                  <div>
                    Максимальное время ожидания курьера на адресе 15 минут
                    (примерка, выбор товара).
                  </div>
                  <div>
                    *Если вы отказываетесь от заказа в момент его получения,
                    доставка становится платной – вы оплачиваете работу курьера
                    (300 руб.)
                  </div>
                  <div>
                    Обратите внимание: курьеры не являются специалистами в
                    области медицины и не консультируют по изделиям.
                  </div>
                </div>
              </div>
              <div v-if="delivery.region == 'region'" class="mt-20">
                <div>Бесплатно* при сумме покупки от 2000 рублей;</div>
                <div>
                  При сумме покупки до 2000 рублей доставка платная — точную
                  стоимость доставки вам озвучит оператор при подтверждении
                  заказа.
                </div>
                <div>Интервалы доставки: 10:00 — 21:00;</div>
                <div>Дни доставки: ежедневно</div>
                <div>
                  *Если вы отказываетесь от заказа в момент его получения,
                  доставка становится платной – вы оплачиваете работу курьера
                  (300 руб.)
                </div>
                <br />
                <div>
                  Обратите внимание: курьеры не являются специалистами в области
                  медицины и не консультируют по изделиям.
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /popup__wrapper -->
      </div>
    </transition>
  </teleport>
</template>

<script>
import { mapState } from "pinia";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import Icon from "@/pages/product_card/components/Icon/Icon.vue";

export default {
  name: "DeliveryTime",
  props: {
    delivery: {},
  },
  components: { Icon },
  setup() {
    const store = useProductStore();
    return {
      store,
    };
  },
  computed: {
    ...mapState(useProductStore, [
      "canAddCart",
      "canReserve",
      "notAvailable",
      "getSelectedOffer",
      "isShippingRestriction",
      "isDeliveryOptionsVisible",
    ]),
    isCityPresence() {
      return window.isCityPresenceApp;
    },
  },
  data() {
    return {
      isShow: false,
      isShowSalon: false,
      isShowCourier: false,
      isAnimate: false,
    };
  },
  methods: {
    getEnd(salons) {
      return salons % 10 == 1 && salons % 100 != 11 ? "е" : "ах";
    },
    moreSalons() {
      return (
        this.store.getSelectedOffer?.addition === true &&
        parseInt(this.delivery.total_salons) -
          parseInt(this.getReserveSalons()) >
          0
      );
    },
    getReserveSalons() {
      return parseInt(
        this.offerSelected()
          ? this.store.getSelectedOffer?.reserve_count
          : this.delivery.default_reserve
      );
    },
    offerSelected() {
      let params = new URL(document.location).searchParams;
      return parseInt(params.get("offer")) > 0;
    },
    reserveClass() {
      return this.canReserve && this.offerSelected() ? "reserve" : "";
    },
    showPopup() {
      this.isShow = true;
      this.isAnimate = true;
    },
    closePopup() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShow = false;
      }, 150);
    },
    showPopupSalon() {
      var reserveButton = document.querySelector(".reserve_button");
      if (reserveButton) {
        reserveButton.dispatchEvent(new Event("click"));
        return;
      }
      this.isShowSalon = true;
      this.isAnimate = true;
    },
    closePopupSalon() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShowSalon = false;
      }, 150);
    },
    showCourierPopup() {
      this.isShowCourier = true;
      this.isAnimate = true;
    },
    closeCourierPopup() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShowCourier = false;
      }, 150);
    },
  },
};
</script>

<!-- <style lang="scss">
@import "./address.scss";
</style> -->
